!function($) {

  var quoteHolderSelector = '.sc-raq-add-to-quote-btn-hldr, .sc-raq-add-to-quote-btn-hldr, .prod-page-raq-btn-holder';
  var quoteButtonSelector = '.sc-raq-add-to-quote-btn, .sc-raq-add-to-quote-btn';
  var cardSelector = 'article.kg-card-product, .search-result.search-result-product';
  var syncing = false;

  function kgCardFromNode(node) {
    var card = node.closest(cardSelector);
    if (card) return card;
    var item = node.closest('.item.collection-product, .item');
    if (!item) return null;
    return item.querySelector(cardSelector) || item;
  }

  function kgIsSoldOutCard(card) {
    if (!card) return false;
    return card.classList.contains('sold-out') || !!card.querySelector('button.add-to-cart.disabled, button.add-to-cart[disabled]');
  }

  function kgHideSoldOut(scope) {
    if (!scope) return;
    scope.classList.add('kg-show-quote');
    scope.querySelectorAll('button.add-to-cart.disabled, button.add-to-cart[disabled], button.add-to-cart[aria-disabled="true"]').forEach(function(btn) {
      btn.style.display = 'none';
    });
  }

  function kgEnsureActions(card) {
    var actions = card.querySelector('.actions');
    if (actions) return actions;
    var details = card.querySelector('.product-details') || card;
    actions = document.createElement('div');
    actions.className = 'actions';
    details.appendChild(actions);
    return actions;
  }

  function kgHasQuoteButton(holder) {
    return !!(holder && (holder.querySelector(quoteButtonSelector) || holder.querySelector('button')));
  }

  function kgSetQuoteIds(node, productId, variantId, collectionIds) {
    node.setAttribute('scr-pid', productId);
    node.setAttribute('scr-pid', productId);
    node.setAttribute('scr-vid', variantId);
    node.setAttribute('scr-vid', variantId);
    if (collectionIds) {
      node.setAttribute('scr-pcoll', collectionIds);
      node.setAttribute('scr-pcoll', collectionIds);
    }
    node.querySelectorAll('button, [scr-pid], [scr-pid], [scr-vid], [scr-vid]').forEach(function(el) {
      el.setAttribute('scr-pid', productId);
      el.setAttribute('scr-pid', productId);
      el.setAttribute('scr-vid', variantId);
      el.setAttribute('scr-vid', variantId);
    });
  }

  function kgOriginalQuoteButton() {
    var holders = document.querySelectorAll(quoteHolderSelector);
    for (var i = 0; i < holders.length; i++) {
      if (holders[i].classList.contains('kg-quote-cloned')) continue;
      var btn = holders[i].querySelector(quoteButtonSelector) || holders[i].querySelector('button');
      if (btn) return btn;
    }
    return document.querySelector(quoteButtonSelector);
  }

  function kgTriggerQuote(productId, variantId) {
    var origBtn = kgOriginalQuoteButton();
    if (!origBtn || !productId || !variantId) return false;

    var origHolder = origBtn.closest(quoteHolderSelector);
    var attrs = ['scr-pid', 'scr-pid', 'scr-vid', 'scr-vid'];
    var saved = [];
    [origBtn, origHolder].forEach(function(el) {
      if (!el) return;
      attrs.forEach(function(attr) {
        saved.push({ el: el, attr: attr, value: el.getAttribute(attr) });
      });
    });

    origBtn.setAttribute('scr-pid', productId);
    origBtn.setAttribute('scr-pid', productId);
    origBtn.setAttribute('scr-vid', variantId);
    origBtn.setAttribute('scr-vid', variantId);
    if (origHolder) {
      origHolder.setAttribute('scr-pid', productId);
      origHolder.setAttribute('scr-pid', productId);
      origHolder.setAttribute('scr-vid', variantId);
      origHolder.setAttribute('scr-vid', variantId);
    }

    origBtn.click();

    window.setTimeout(function() {
      saved.forEach(function(item) {
        if (item.value === null) item.el.removeAttribute(item.attr);
        else item.el.setAttribute(item.attr, item.value);
      });
    }, 50);

    return true;
  }

  function kgMoveQuoteToActions(holder) {
    var card = kgCardFromNode(holder);
    if (!card || !kgHasQuoteButton(holder)) return;
    if (!kgIsSoldOutCard(card)) return;
    var actions = kgEnsureActions(card);
    if (holder.parentElement !== actions) actions.appendChild(holder);
    kgHideSoldOut(card);
  }

  function kgRemoveEmptyQuoteHolders(card) {
    card.querySelectorAll(quoteHolderSelector).forEach(function(holder) {
      if (!kgHasQuoteButton(holder)) holder.parentNode.removeChild(holder);
    });
  }

  function kgCloneQuoteForSoldOutCards() {
    var sample = null;
    document.querySelectorAll(quoteHolderSelector).forEach(function(holder) {
      if (!sample && kgHasQuoteButton(holder) && !holder.classList.contains('kg-quote-cloned')) {
        sample = holder;
      }
    });
    if (!sample) return;

    var sampleColl = sample.getAttribute('scr-pcoll') || sample.getAttribute('scr-pcoll') || '';

    document.querySelectorAll(cardSelector).forEach(function(card) {
      if (!kgIsSoldOutCard(card)) return;
      kgRemoveEmptyQuoteHolders(card);
      if (card.querySelector(quoteHolderSelector + ' button, ' + quoteButtonSelector)) {
        kgHideSoldOut(card);
        return;
      }

      var productId = card.getAttribute('data-product-id');
      var variantId = card.getAttribute('data-variant-id');
      if (!productId || !variantId) return;

      var clone = sample.cloneNode(true);
      clone.classList.add('kg-quote-cloned');
      clone.removeAttribute('id');
      kgSetQuoteIds(clone, productId, variantId, card.getAttribute('data-collection-ids') || sampleColl);
      kgEnsureActions(card).appendChild(clone);
      kgHideSoldOut(card);
    });
  }

  function kgSyncQuoteButtons() {
    if (syncing) return;
    syncing = true;

    document.querySelectorAll(quoteHolderSelector).forEach(function(holder) {
      if (holder.closest('article.product-detail')) {
        if (kgHasQuoteButton(holder)) {
          kgHideSoldOut(holder.closest('article.product-detail'));
          document.querySelectorAll('#sticky-cart button.add-to-cart.disabled, .sticky-cart button.add-to-cart.disabled, .sticky-cart-action').forEach(function(el) {
            el.style.display = 'none';
          });
        }
        return;
      }
      kgMoveQuoteToActions(holder);
    });

    kgCloneQuoteForSoldOutCards();
    syncing = false;
  }

  document.addEventListener('click', function(e) {
    var cloned = e.target.closest('.kg-quote-cloned');
    if (!cloned) return;
    var btn = e.target.closest('button, .sc-raq-add-to-quote-btn, .sc-raq-add-to-quote-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    kgTriggerQuote(btn.getAttribute('scr-pid') || cloned.getAttribute('scr-pid'), btn.getAttribute('scr-vid') || cloned.getAttribute('scr-vid'));
  }, true);

  $(function() {
    kgSyncQuoteButtons();
    window.setTimeout(kgSyncQuoteButtons, 500);
    window.setTimeout(kgSyncQuoteButtons, 1500);
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function() {
      kgSyncQuoteButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

}(jQuery);
